import { createReducer, on } from '@ngrx/store';
import {
  clearProductPriceByKey,
  loadProductPrice,
  loadProductPriceFailure,
  loadProductPriceSuccess,
} from './product-price.actions';

export interface ProductPriceState {
  cache: { [key: string]: any[] };
  loading: { [key: string]: boolean };
  error: { [key: string]: string | null };
}

export const initialState: ProductPriceState = {
  cache: {},
  loading: {},
  error: {},
};

export const productPriceReducer = createReducer(
  initialState,
  on(loadProductPrice, (state, { key }) => ({
    ...state,
    loading: { ...state.loading, [key]: true },
    error: { ...state.error, [key]: null },
  })),
  on(loadProductPriceSuccess, (state, { key, data }) => ({
    ...state,
    cache: { ...state.cache, [key]: data ?? [] },
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: null },
  })),
  on(loadProductPriceFailure, (state, { key, error }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: error },
  })),
  on(clearProductPriceByKey, (state, { key }) => {
    const { [key]: _, ...restCache } = state.cache;
    const { [key]: __, ...restLoading } = state.loading;
    const { [key]: ___, ...restError } = state.error;
    return {
      ...state,
      cache: restCache,
      loading: restLoading,
      error: restError,
    };
  }),
);
